import { useLocation } from "react-router-dom";

export function useGetShiftIdWithOrientationRequired() {
  const location = useLocation();
  return new URLSearchParams(location.search).get("shiftIdWithOrientationRequired") ?? undefined;
}
